import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const PreviewScheduledContentModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "PreviewScheduledContentModalContainer" */
      './PreviewScheduledContentModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
